<template lang="pug">

  form-group-row(:form="form", :label="label", name="email", required)
    form-input(:form="form", name="email", type="email", :disabled="disabled")

</template>

<script>

export default {
  name: 'user-input-email',

  props: {
    label: {
      type: String,
      default: 'Email',
    },
    disabled: {
      type: Boolean,
      default: false,
    }
  },

  data: () => ({
    form: null,
  }),

  async created() {
    this.form = this.$parent.form;
    this.form.email = this.$parent.user ? this.$parent.user.email : '';
  },
}

</script>
